import { USER_RESET_PASSWORD_REQUEST, USER_RESET_PASSWORD_SUCCESS, USER_RESET_PASSWORD_FAILURE } from '../../constants/password.constants';

export const resetPasswordRequest = (token, new_password) => ({
    type: USER_RESET_PASSWORD_REQUEST,
    token,
    new_password,
});

export const resetPasswordRequestSuccess = () => ({
    type: USER_RESET_PASSWORD_SUCCESS,
});

export const resetPasswordRequestFailure = error => ({
    type: USER_RESET_PASSWORD_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/App/redux/actions/account_actions/reset_password_actions.js